import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
`;

export const HelpMessage = styled.p`
  display: none;
  align-items: center;
  height: 30px;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.shopl[100]};
`;

export const InputBox = styled.div<{ isError: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  width: inherit;
  box-sizing: border-box;
  padding: 11px 12px;
  border: 1px solid ${({ isError, theme }) => (isError ? theme.colors.red[200] : theme.colors.neutral[100])};
  border-radius: 6px;
  &:hover {
    border: 1px solid ${({ theme, isError }) => (isError ? theme.colors.red[200] : theme.colors.neutral[400])};
  }

  &:focus-within {
    border: 1px solid ${({ theme, isError }) => (isError ? theme.colors.red[200] : theme.colors.neutral[700])};
  }

  &:focus-within {
    button {
      display: flex;
    }

    & + ${HelpMessage} {
      display: flex;
    }
  }

  &[data-theme='primary'] {
    background-color: ${({ theme }) => theme.colors.neutral[0]};
  }

  &[data-theme='secondary'] {
    background-color: ${({ theme }) => theme.colors.neutral[150]};
    input::placeholder {
      color: ${({ theme }) => theme.colors.neutral[350]};
    }
    &:focus-within {
      background-color: #fff;
    }
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin: 10px 0;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;

export const Required = styled.div`
  color: ${({ theme }) => theme.colors.red[300]};
  font-weight: bold;
  font-size: 14px;
  height: 20px;
  margin-left: 3px;
`;

export const StyledInput = styled.input<{ fontSize: string; withView: boolean }>`
  width: ${({ withView }) => (withView ? '95%' : '100%')};
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.neutral[700]};
  font-size: ${({ fontSize }) => fontSize};
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral[350]};
  }

  &:-webkit-autofill {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:hover {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:focus {
    box-shadow: 0 0 0 30px white inset !important;
  }
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  &[type='password']::-ms-reveal,
  &[type='password']::-ms-clear {
    display: none;
  }
`;

export const themes = {
  primary: css`
    background-color: #fff;
  `,
  secondary: css`
    background-color: #f6f6f6;
    input::placeholder {
      color: #ccc;
    }
    &:focus-within {
      background-color: #fff;
    }
  `,
};

export const withIconStyle = css`
  padding: 0.5rem 0.875rem 0.5rem 3.875rem;
`;

export const ViewBtn = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  right: 3px;
  width: 32px;
  height: 32px;
  background-color: transparent !important;
  cursor: pointer;
  svg {
    width: 0.875rem;
    height: 0.75rem;
  }
`;

export const CloseBtn = styled(ViewBtn)<{
  closeBtnWidth?: string;
  withView?: boolean;
}>`
  display: none;
  right: ${({ withView }) => withView && '37px'};
  width: ${({ closeBtnWidth }) => closeBtnWidth};
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ChildrenIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 1rem;
  transform: translateY(-50%);
  height: 20px;
`;

// const StyledWarnMessage = styled.div`
//     height: 30px;
// `;
